@if (!loadOption || loadOption == "HAENGIGE") {
  <h3>{{ "HängigeGeogeschäfte" | translate }}</h3>
}
@if (loadOption && loadOption == "ALLE") {
  <h3>{{ "Geogeschäfte" | translate }}</h3>
}

<cap-list-loader [hasRight]="hasRight" [listLoader]="haengigeLoader">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'HängigeGeogeschäfte' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer; width: 15%">
      <cap-column-header [columnName]="'Nummer'" [sortModel]="tableSortModel.columns.get('nummer')"></cap-column-header>
    </th>
    @if (avGeschaeftErweiterung) {
      <th class="noselect" style="cursor: pointer; width: 15%">
        <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
      </th>
    }
    <th class="noselect" style="cursor: pointer; width: 10%">
      <cap-column-header [columnName]="'DatumAuftrag'" [sortModel]="tableSortModel.columns.get('auftragsDatum')"></cap-column-header>
    </th>
    @if (avGeschaeftErweiterung) {
      <th class="noselect" style="cursor: pointer; width: 15%">
        <cap-column-header [columnName]="'AvMutation'" [sortModel]="tableSortModel.columns.get('avMutation')"></cap-column-header>
      </th>
    }
    @if (avGeschaeftErweiterung) {
      <th class="noselect" style="cursor: pointer; width: 20%">
        <cap-column-header [columnName]="'Geschäftstyp'" [sortModel]="tableSortModel.columns.get('geoGeschaeftsArt')"></cap-column-header>
      </th>
    }
    <th class="noselect" style="width: 25%">
      {{ "Beschreibung" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (geschaeft of haengigeLoader?.items; track geschaeft) {
    <tr>
      <td>
        <cap-kompakt-geometergeschaeft
          [canViewGeoGeschaeftDetails]="canViewGeoGeschaeftDetails"
          [item]="geschaeft.geometergeschaeft"></cap-kompakt-geometergeschaeft>
      </td>
      @if (avGeschaeftErweiterung) {
        <td>
          <cap-link
            [enableNavigation]="canViewGeoGeschaeftDetails"
            [params]="[geschaeft.id.id]"
            [target]="navTargets.NAV_GEOMETERGESCHAEFT">
            {{ geschaeft.status | translate }}
          </cap-link>
        </td>
      }
      <td>
        <cap-link [enableNavigation]="canViewGeoGeschaeftDetails" [params]="[geschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geschaeft.auftragsDatum | datum }}
        </cap-link>
      </td>
      @if (avGeschaeftErweiterung) {
        <td>
          <cap-kompakt-av-mutation [item]="geschaeft.avMutation"></cap-kompakt-av-mutation>
        </td>
      }
      @if (avGeschaeftErweiterung) {
        <td>
          <cap-link
            [enableNavigation]="canViewGeoGeschaeftDetails"
            [params]="[geschaeft.id.id]"
            [target]="navTargets.NAV_GEOMETERGESCHAEFT">
            {{ geschaeft.geoGeschaeftsArt | translate }}
          </cap-link>
        </td>
      }
      <td>
        @if (geschaeft.mBeschreibung.access !== "NONE") {
          <span>
            <cap-link
              [enableNavigation]="canViewGeoGeschaeftDetails"
              [params]="[geschaeft.id.id]"
              [target]="navTargets.NAV_GEOMETERGESCHAEFT"
              >{{ geschaeft.beschreibung }}</cap-link
            >
          </span>
        }
        @if (geschaeft.mBeschreibung.access === "NONE") {
          <span>{{"gemaessGrundbuch" | translate}}</span>
        }
      </td>
    </tr>
  }
</ng-template>
